var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieLineGraphDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 177,
    viewBox: "0 0 178 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9167 40.5625C39.6283 40.5625 29.6667 50.4682 29.6667 62.6875C29.6667 74.9068 39.6283 84.8125 51.9167 84.8125C64.205 84.8125 74.1667 74.9068 74.1667 62.6875C74.1667 50.4682 64.205 40.5625 51.9167 40.5625ZM22.25 62.6875C22.25 46.3951 35.5322 33.1875 51.9167 33.1875C68.3011 33.1875 81.5833 46.3951 81.5833 62.6875C81.5833 78.9799 68.3011 92.1875 51.9167 92.1875C35.5322 92.1875 22.25 78.9799 22.25 62.6875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9168 33.1875C53.9649 33.1875 55.6252 34.8384 55.6252 36.875V59H77.8752C79.9232 59 81.5835 60.6509 81.5835 62.6875C81.5835 64.7241 79.9232 66.375 77.8752 66.375H51.9168C49.8688 66.375 48.2085 64.7241 48.2085 62.6875V36.875C48.2085 34.8384 49.8688 33.1875 51.9168 33.1875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0519 132.754C80.0976 132.851 81.6768 134.579 81.5791 136.613C81.026 148.131 76.8566 159.187 69.6571 168.227C68.3855 169.823 66.0532 170.093 64.4477 168.828C62.8421 167.564 62.5714 165.245 63.8429 163.648C70.0798 155.817 73.6917 146.24 74.1709 136.262C74.2686 134.227 76.0061 132.657 78.0519 132.754Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.948 132.754C101.994 132.657 103.731 134.227 103.829 136.262C104.308 146.24 107.92 155.817 114.157 163.648C115.429 165.245 115.158 167.564 113.552 168.828C111.947 170.093 109.614 169.823 108.343 168.227C101.143 159.187 96.9739 148.131 96.4208 136.613C96.3231 134.579 97.9023 132.851 99.948 132.754Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9092 165.938C51.9092 163.901 53.5695 162.25 55.6175 162.25H122.368C124.416 162.25 126.076 163.901 126.076 165.938C126.076 167.974 124.416 169.625 122.368 169.625H55.6175C53.5695 169.625 51.9092 167.974 51.9092 165.938Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 114.312C0 112.276 1.66028 110.625 3.70833 110.625H174.292C176.34 110.625 178 112.276 178 114.312C178 116.349 176.34 118 174.292 118H3.70833C1.66028 118 0 116.349 0 114.312Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.125 14.75C9.07694 14.75 7.41667 16.4009 7.41667 18.4375V129.062C7.41667 131.099 9.07694 132.75 11.125 132.75H166.875C168.923 132.75 170.583 131.099 170.583 129.062V18.4375C170.583 16.4009 168.923 14.75 166.875 14.75H11.125ZM0 18.4375C0 12.3278 4.98083 7.375 11.125 7.375H166.875C173.019 7.375 178 12.3278 178 18.4375V129.062C178 135.172 173.019 140.125 166.875 140.125H11.125C4.98083 140.125 0 135.172 0 129.062V18.4375Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.416 30.3548C155.989 31.6585 156.202 33.9838 154.891 35.5483L136.349 57.6733C135.038 59.2378 132.699 59.4492 131.126 58.1454L111.875 42.1927L103.092 53.8376C101.863 55.4668 99.5385 55.797 97.9001 54.5751C96.2616 53.3532 95.9296 51.0418 97.1584 49.4126L108.283 34.6626C108.893 33.854 109.81 33.3298 110.82 33.2125C111.829 33.0952 112.843 33.3952 113.624 34.0423L133.025 50.1191L149.193 30.8269C150.504 29.2624 152.842 29.051 154.416 30.3548Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.625 77.4375C146.673 77.4375 148.333 79.0884 148.333 81.125V92.1875C148.333 94.2241 146.673 95.875 144.625 95.875C142.577 95.875 140.917 94.2241 140.917 92.1875V81.125C140.917 79.0884 142.577 77.4375 144.625 77.4375Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.792 73.75C131.84 73.75 133.5 75.4009 133.5 77.4375V92.1875C133.5 94.2241 131.84 95.875 129.792 95.875C127.744 95.875 126.083 94.2241 126.083 92.1875V77.4375C126.083 75.4009 127.744 73.75 129.792 73.75Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.958 66.375C117.006 66.375 118.667 68.0259 118.667 70.0625V92.1875C118.667 94.2241 117.006 95.875 114.958 95.875C112.91 95.875 111.25 94.2241 111.25 92.1875V70.0625C111.25 68.0259 112.91 66.375 114.958 66.375Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.125 77.4375C102.173 77.4375 103.833 79.0884 103.833 81.125V92.1875C103.833 94.2241 102.173 95.875 100.125 95.875C98.0768 95.875 96.4165 94.2241 96.4165 92.1875V81.125C96.4165 79.0884 98.0768 77.4375 100.125 77.4375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieLineGraphDesktop);
export default __webpack_public_path__ + "static/media/Pie_Line_Graph_Desktop.b49273686bb3ed5bc14c9f9e6e307146.svg";
export { ForwardRef as ReactComponent };